import { render, staticRenderFns } from "./ApproveRemarkDialog.vue?vue&type=template&id=3050631e"
import script from "./ApproveRemarkDialog.vue?vue&type=script&lang=js"
export * from "./ApproveRemarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports